import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { oauthApplicationsRouter } from './routing/oauthApplicationsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { oauthApplicationsAccessControl } from './access-control/oauthApplicationsAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'oauth-applications',
  routes,
  translations: {},
  lazyTranslations: {
    EN_US: () => import('./translations/en-US.json'),
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    partnerScoped: [oauthApplicationsRouter],
  },
  navigationEntries: [
    {
      attachToV3: NavEntryPointV3.Developer,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Manage OAuth applications and API credentials for developer integrations',
          labelId: 'oauthApplicationsDomain.title',
          labelIdV3: 'oauthApplicationsDomain.title.v3',
          route: 'oauth-applications-list',
          accessControl: oauthApplicationsAccessControl,
          position: 3,
          positionNavV3: 2,
          inToolPermissions: [
            {
              slug: Permission.RetailerCredentialManagementView,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.RetailerCredentialManagementView,
            },
            {
              slug: Permission.RetailerCredentialManagementModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.RetailerCredentialManagementModify,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'oauth-applications-dashboard-tool',
  },
}

export default definition
